// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_bo-0";
export var orangeButton = "_bo-1";